// i18n-Infrastruktur (de/en, vorbereitet für es/pt/ar/he/zh).
// Detection: localStorage (Key `ca_lang`) → navigator. Fallback: de.
//
// RTL-Vorbereitung: Sprachen mit RTL-Schreibrichtung (ar, he) kippen
// document.documentElement.dir automatisch auf "rtl", sobald sie als Locales
// dazukommen — das Layout sollte ab dann logische CSS-Properties nutzen
// (ms-*/me-* statt ml-*/mr-*); die Tailwind-Klassen sind heute noch physisch.

import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import de from "./locales/de.json";
import en from "./locales/en.json";

// Sprachen mit Rechts-nach-links-Schreibrichtung.
export const RTL_LANGS = ["ar", "he"];

function applyDocumentLanguage(lng: string): void {
  const base = lng.split("-")[0];
  document.documentElement.lang = base;
  document.documentElement.dir = RTL_LANGS.includes(base) ? "rtl" : "ltr";
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
    },
    fallbackLng: "de",
    supportedLngs: ["de", "en"],
    nonExplicitSupportedLngs: true,
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "ca_lang",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
  });

applyDocumentLanguage(i18n.language || "de");
i18n.on("languageChanged", applyDocumentLanguage);

export default i18n;
